import * as React from "react";
import { FullAuthUrl } from "./Environment";

export default class Install extends React.PureComponent {
    render() {
        return <div className="jumbotron">
            <h1>TestOut HubSpot Extension</h1>
            <p className="lead">This app provides additional HubSpot functionality for TestOut Employees. The button below can be used to install the application into your HubSpot Account.</p>
            <p><a href={FullAuthUrl} className="btn btn-primary btn-lg">Install TestOut HubSpot Extension</a></p>
        </div>;
    }
}